import React from 'react';
import { UserSystemGroup } from 'store/storeTypes';
import { ITopCardsProps } from './TopCardsContainer';
import MobileApolloTopCards from './MobileApolloTopCards';
import MobileDtfTopCards from './MobileDtfTopCards';
import MobileDtgTopCards from './MobileDtgTopCards';

const MobileTopCards = (props: ITopCardsProps) => {
  const { selectedSystemGroup } = props;

  if (UserSystemGroup.DTF === selectedSystemGroup) {
    return <MobileDtfTopCards {...props} />;
  }
  if (UserSystemGroup.Apollo === selectedSystemGroup) {
    return <MobileApolloTopCards {...props} />;
  }
  return <MobileDtgTopCards {...props} />;
};

export default MobileTopCards;
